import { render, staticRenderFns } from "./AttributeList.vue?vue&type=template&id=3e29364a&scoped=true&"
import script from "./AttributeList.vue?vue&type=script&lang=js&"
export * from "./AttributeList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e29364a",
  null
  
)

export default component.exports